import React from 'react';
import SEO from '../components/SEO';
import Header from "../partials/header/Header";
import IntroTwo from '../container/IntroSlider/IntroTwo';

import Footer from '../container/Footer/Footer';
import ScrollToTop from '../components/ScrollToTop.jsx';
import HomeCards from '../container/Work/HomeCards';
import HomeSkillWithImage from '../container/HomeSkillWithVideo/HomeSkillWithImage';
import TestimonialSlider from '../container/Testimonial/TestimonialSlider';
import BussinessCards from '../container/Work/BussinessCards';
import HomeScheduleSection from '../container/ContactInformation/HomeScheduleSection';
import PopUp from './PopUp/PopUp';
import FactSlider from '../container/ContactInformation/FactSlider';
// import Loader from 'react-loaders'
// import LoaderBack from './LoaderBack';
// import VerticalSlider from '../container/Work/VerticalSlider';
// import PopUp from './PopUp/PopUp';




const HomeTwo = () => {
    return (
        <React.Fragment>
            
            <SEO title="Ikabit Inc. - Home" />
            <Header />
          
            <IntroTwo />
            <HomeCards/>
           
            <HomeSkillWithImage/>
            <TestimonialSlider/>
            {/* <AboutSec1/> */}
            {/* <VerticalSlider/> */}
            <FactSlider/>
            <BussinessCards/>
            <HomeScheduleSection/>
            {<PopUp /> }
            <Footer />
            <ScrollToTop />
            {/* <LoaderBack />
            <Loader type="line-scale"/> */}
        </React.Fragment>
       
     
    )
}

export default HomeTwo;



